var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#4337C9",
    strokeWidth: 0.6,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.249 17.095 18.718 6.803 14.344 20M5.25 17.095l4.547 1.453M5.25 17.095 4.274 6.528M14.344 20l-4.548-1.452M14.344 20 22 12.638l-5.607 1.177m-6.597 4.733 2.6-3.481m-8.122-8.54 5.797 6.862M4.274 6.528 2 9.082l2.474-.226m8.471 2.304L10.971 5l-2.317 6.661"
  })));
};
export default SvgLogo;